import { theme } from './../../theme/theme';
import styled from 'styled-components'

export const PageWrap = styled('div')`
  padding-bottom: ${theme.offsets.extraBig};
`